import { render, staticRenderFns } from "./AssetsType.vue?vue&type=template&id=1319af76&scoped=true&"
import script from "./AssetsType.vue?vue&type=script&lang=js&"
export * from "./AssetsType.vue?vue&type=script&lang=js&"
import style0 from "./AssetsType.vue?vue&type=style&index=0&id=1319af76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1319af76",
  null
  
)

export default component.exports